(() => {
  const TITLE_OVERFLOW_THRESHOLD_PX = 18;
  let resizeTimer;

  const measureTitleDisclosure = (title, index) => {
    if (!(title instanceof HTMLElement)) return;

    const wasExpanded = title.classList.contains('rpm-product-title--expanded');
    title.classList.remove('rpm-product-title--expanded');

    const overflow = Math.ceil(title.scrollHeight - title.clientHeight);
    const needsDisclosure = overflow > TITLE_OVERFLOW_THRESHOLD_PX;
    let button = title.nextElementSibling;
    if (!(button instanceof HTMLButtonElement) || !button.matches('[data-rpm-title-toggle]')) button = null;

    if (!needsDisclosure) {
      button?.remove();
      title.dataset.rpmTitleReady = 'false';
      return;
    }

    if (!button) {
      button = document.createElement('button');
      if (!title.id) title.id = `rpm-product-title-${index + 1}`;
      button.type = 'button';
      button.className = 'rpm-product-title-toggle';
      button.dataset.rpmTitleToggle = 'true';
      button.setAttribute('aria-controls', title.id);
      button.addEventListener('click', () => {
        const expanded = title.classList.toggle('rpm-product-title--expanded');
        button.textContent = expanded ? 'See less' : 'See all';
        button.setAttribute('aria-expanded', String(expanded));
      });
      title.insertAdjacentElement('afterend', button);
    }

    if (wasExpanded) title.classList.add('rpm-product-title--expanded');
    const expanded = title.classList.contains('rpm-product-title--expanded');
    button.textContent = expanded ? 'See less' : 'See all';
    button.setAttribute('aria-expanded', String(expanded));
    title.dataset.rpmTitleReady = 'true';
  };

  const setupTitleDisclosure = () => {
    document.querySelectorAll('.product-details h1').forEach(measureTitleDisclosure);
  };

  const updateVariantMpn = () => {
    document.querySelectorAll('[data-rpm-product-heading-meta]').forEach((root) => {
      const mapNode = root.parentElement?.querySelector('[data-rpm-variant-mpn-map]') || root.nextElementSibling;
      if (!(mapNode instanceof HTMLScriptElement)) return;
      let map = {};
      try { map = JSON.parse(mapNode.textContent || '{}'); } catch { return; }
      const productDetails = root.closest('.product-details') || document;
      const variantInput = productDetails.querySelector('product-form-component input[name="id"]') || document.querySelector('product-form-component input[name="id"]');
      const target = root.querySelector('[data-rpm-current-mpn]');
      if (!target || !(variantInput instanceof HTMLInputElement)) return;
      const mpn = map[variantInput.value];
      if (mpn) target.textContent = mpn;
    });
  };

  const syncQuantityVariantId = (eventTarget, detail) => {
    const variantId = detail?.resource?.id;
    if (!variantId) return;

    const section = eventTarget instanceof Element ? eventTarget.closest('.shopify-section') : null;
    const scope = section || document;
    scope.querySelectorAll('quantity-selector-component[data-variant-id]').forEach((selector) => {
      selector.dataset.variantId = String(variantId);
    });
    scope.querySelectorAll('price-per-item[data-variant-id]').forEach((price) => {
      price.dataset.variantId = String(variantId);
    });
  };

  const FITMENT_STATES = new Set(['unselected', 'checking', 'fits', 'does-not-fit', 'unknown']);
  const FITMENT_MESSAGES = {
    unselected: 'Select a vehicle to check fitment',
    checking: 'Checking vehicle fitment…',
    fits: 'Fits your selected vehicle',
    'does-not-fit': 'Does not fit your selected vehicle',
    unknown: 'Fitment could not be confirmed',
  };

  const updateFitmentStatus = (detail = {}) => {
    const state = FITMENT_STATES.has(detail.state) ? detail.state : 'unknown';
    document.querySelectorAll('[data-rpm-fitment-status]').forEach((root) => {
      if (!(root instanceof HTMLElement)) return;
      if (detail.productId && String(detail.productId) !== root.dataset.productId) return;

      const message = root.querySelector('[data-rpm-fitment-message]');
      root.dataset.fitmentState = state;
      if (message) message.textContent = detail.message || FITMENT_MESSAGES[state];
    });
  };

  document.addEventListener('rpm:fitment:update', (event) => {
    updateFitmentStatus(event.detail);
  });

  document.addEventListener('shopify:product:select', (event) => {
    if (!event.promise || !(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      .then(({ detail }) => {
        syncQuantityVariantId(event.target, detail);
        updateVariantMpn();
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[rpm-product] Variant synchronization failed:', error);
      });
  });

  document.addEventListener('change', (event) => {
    if (event.target instanceof Element && event.target.closest('variant-picker')) {
      setTimeout(updateVariantMpn, 180);
      setTimeout(updateVariantMpn, 500);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    updateVariantMpn();
    setupTitleDisclosure();
    document.fonts?.ready.then(setupTitleDisclosure);
  });

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setupTitleDisclosure, 120);
  });

  window.addEventListener('pageshow', () => {
    updateVariantMpn();
    setupTitleDisclosure();
  });

  window.RPMFitmentStatus = Object.freeze({
    update(detail) {
      document.dispatchEvent(new CustomEvent('rpm:fitment:update', { detail }));
    },
  });
})();
